import userflow from 'userflow.js';
import { userFlowContents } from '@config';

const SIGNED_UP_AT = new Date().toISOString();

/**
 * In this service was implemented some esentials methods of userflow.js
 * for more methods if you need help, please refeere https://userflow.com/docs/userflow-js
 */

const setIdentity = (user) => {
	if (typeof user === 'object') {
		userflow.identify(user.Id, {
			name         : `${user.FirstName} ${user.LastName}`,
			email        : user.Email,
			// eslint-disable-next-line camelcase
			user_type_id : user.UserTypeId,
			signedUpAt   : SIGNED_UP_AT,
		});

		if (user.Organization) {
			const { Organization } = user;
			userflow.group(Organization.Id, {
				name                 : Organization.Name,
				// eslint-disable-next-line camelcase
				organization_type_id : Organization.OrganizationTypeId,
			});
		}
	}
};

const initUserFlow = (user) => {
	userflow.init(userFlowContents.token);
	setIdentity(user);
};

const startFlow = (flowContentID, showOnce = false) => {
	userflow.start(flowContentID, { once : showOnce });
};

const resetSession = () => {
	userflow.reset();
};

export default {
	initUserFlow,
	resetSession,
	startFlow,
};
